import React from 'react'
import firstPlan from 'images/content/plan-1-1-570x548.png'
import secondPlan from 'images/content/plan-2-570x548.png'

const ThirdSection = () => {
  return (
    <>
        <div className='font-bold text-2xl sm:text-4xl text-center'>Health Coverage Comparison</div>
        <div className='flex flex-wrap justify-center gap-y-4'>
            <img src={firstPlan} alt='plans' />
            <img src={secondPlan} alt='plans' />
        </div>
    </>
  )
}

export default ThirdSection